import { NavLink, Outlet, useLocation } from "react-router-dom";

import {
  MdArrowDropDown,
  MdArrowDropUp,
  MdOutlineDashboard,
  MdOutlineCorporateFare,
  MdSupervisedUserCircle,
} from "react-icons/md";
import { BsCalculator } from "react-icons/bs";
import { FiSettings } from "react-icons/fi";
import {
  FaTelegramPlane,
  FaUsers,
  FaDollarSign,
  FaCheck,
  FaFileExcel,
  FaMobileAlt,
  FaRegCalendarCheck,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

import "./style.css";
import { IconContext } from "react-icons";
import { memo, useContext, useEffect, useState } from "react";
import { ManageCPFCal } from "../../_service";
import { updateAppSettingId, updateCpfCalCatogary } from "../../_features";
import { useAppDispatch, useAppSelector } from "../../_app";
import { DashboardContainer, LeftSection, RightSection } from "./Styles";
import { AiFillBook, AiFillClockCircle } from "react-icons/ai";
import exp from "constants";
import { IoHome } from "react-icons/io5";

const activeStyle = {
  color: "#28a745",
  fontWeight: "bold",
};

const routeToSection = {
  "manage-company": "company",
  "employee-list": "employee",
  payment_runs: "payrun",
  monthly: "filing",
  // iras: "filing",
  // ir21: "filing",
  iras: "manual",
  ir21: "manual",
  tms: "tms",
  "manage-users": "users",
  "add-employee": "employeee",
  "self-service": "employee",
  approve: "approve",
  manual: "manual",
  "employee-payroll": "employee",
  reports: "manage-report",
  payslips: "payslips",
  requests: "requests",
  payroll: "payroll",
  "annual-bonus": "annual-bonus",
  "annual-increment": "annual-increment",
  "customer-invoice": "invoice",

  cso: "request",
  "data-entry": "request",
  finalizer: "request",
  reviewer: "request",
  completed: "request",
} as { [key: string]: string };


const Dashboard = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const user = useAppSelector((state) => state.user)
  const userGroupIds = user.groups?.map((group: any) => group.id);
  const isSuperUser = user?.is_superuser || false
  const isEmployee = user?.isEmployee || false;

  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const cpfCatogary = useAppSelector((state) => state.dashboard.cpfCalCatogry);
  // const menu = useAppSelector((state) => Object.keys(state.user.menu_permission));
  const menu = useAppSelector((state) => state.user.menu);
  const groups = useAppSelector((state) => state.user.groups);
  const permission = useAppSelector((state) => state.user.permission);

  const [cpfOpen, setCpfOpen] = useState<boolean>(false);
  const [settingOpen, setSettingOpen] = useState<boolean>(false);
  const [payslipOpen, setPaySlipOpen] = useState<boolean>(false);
  const [templateOpen, setTemplateOpen] = useState<boolean>(false);
  const [ManageInvoicingOpen, setManageInvoicingOpen] = useState<boolean>(false);
  const [GlobalInvoiceopen, setGlobalInvoiceopen] = useState<boolean>(false);
  const [usersOpen, setUsersOpen] = useState<boolean>(false);
  const [tellbossOpen, setTellbossOpen] = useState<boolean>(false);
  const [expenseOpen, setExpenseOpen] = useState<boolean>(false);
  const [manageIR8AOpen, setManageIR8AOpen] = useState<boolean>(false);
  const [manageCustomItemOpen, setManageCustomItemOpen] = useState<boolean>(false);

  const [cpfSelect, setCpfSelect] = useState<boolean>(false);
  const [settingSelect, setSettingSelect] = useState<boolean>(false);
  const [templateSelect, setTemplateSelect] = useState<boolean>(false);
  const [usersSelect, setUsersSelect] = useState<boolean>(false);
  const [payslipSelect, setPayslipSelect] = useState<boolean>(false);
  const [tellbossSelect, setTellbossSelect] = useState<boolean>(false);
  const [GlobalInvoiceselect, setGlobalInvoiceSelect] = useState<boolean>(false);
  const [expenseSelect, setExpenseSelect] = useState<boolean>(false);
  const [manageIR8ASelect, setManageIR8ASelect] = useState<boolean>(false);
  const [manageCustomItemSelect, setManageCustomItemSelect] = useState<boolean>(false);

  const [manageInvoiceSelect, setManageInvoiceSelect] = useState<boolean>(false);


  const [selectedSection, setSelectedSection] = useState("");
  const location = useLocation();

  const currentPayrunDate = useAppSelector(
    (state) => state.user.current_payrun_date
  );
  const payrunStartDate = useAppSelector(
    (state) => state.user.defaultCompanyPayrunStartDate
  );

  const handleLinkOpen = (str: string) => {
    autoScrollToTop();
    if (str === "expense"){
      setExpenseSelect(true);
      setExpenseOpen(true)
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
    }
    if (str === "cpf") {
      setCpfOpen(true);
      setCpfSelect(true);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
      setExpenseSelect(false);

    }
    if (str === "setting") {
      setSettingOpen(true);
      setCpfSelect(false);
      setSettingSelect(true);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
      setExpenseSelect(false);

    }
    if (str === "payslip") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPaySlipOpen(true);
      setPayslipSelect(true);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
      setExpenseSelect(false);

    }
    if (str === "template") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(true);
      setTemplateOpen(true);
      setUsersSelect(false);
      setTellbossSelect(false);
      setExpenseSelect(false);

    }
    if (str === "users") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(true);
      setUsersOpen(true);
      setTellbossSelect(false);
      setExpenseSelect(false);

    }
    // if (str === "tellboss") {
    //   setCpfSelect(false);
    //   setSettingSelect(false);
    //   setPayslipSelect(false);
    //   setTemplateSelect(false);
    //   setUsersSelect(false);
    //   setTellbossSelect(true);
    //   setTellbossOpen(true);
    // }
    if (str === "payroll") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(true);
      setTellbossOpen(true);
      setExpenseSelect(false);

    }

    if (str === "manage_invoice") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
      setManageInvoiceSelect(true);
      setManageInvoicingOpen(true);
      setExpenseSelect(false);
      setManageIR8ASelect(false);


    }
    if (str === "manageIR8A") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
      setManageInvoiceSelect(false);
      setExpenseSelect(false);
      setManageIR8ASelect(true);
      setManageIR8AOpen(true);
    }
    if (str === "manage_custom_item") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
      setManageInvoiceSelect(false);
      setExpenseSelect(false);
      setManageIR8ASelect(false);
      setManageCustomItemSelect(true);
      setManageCustomItemOpen(true);
    }
    if (str === "global_level_invoice") {
      setCpfSelect(false);
      setSettingSelect(false);
      setPayslipSelect(false);
      setTemplateSelect(false);
      setUsersSelect(false);
      setTellbossSelect(false);
      setManageInvoiceSelect(true);
      setExpenseSelect(false);

    }
  };

  const getCPFCalCategory = async () => {
    try {
      const res = await ManageCPFCal._getCpfCalCategory("");
      dispatch(updateCpfCalCatogary(res.data));
    } catch (e) {
      console.error(e);
    }
  };
  const handleAppSettingClick = (e: any) => {
    e.preventDefault();
    // updateAppSettingId
    navigate("app-settings/employer-details");
    dispatch(updateAppSettingId(companyId));
  };

  const handleClick = (to?: string) => {
    autoScrollToTop();
    if (to) {
      console.log("in menu click", to)
      navigate(to);
    }
    setSettingSelect(false);
    setCpfSelect(false);
    setPayslipSelect(false);
    setTemplateSelect(false);
    setUsersSelect(false);
    setTellbossSelect(false);
    setExpenseSelect(false);
    setManageIR8ASelect(false);
    setManageCustomItemSelect(false);
  };

  useEffect(() => {
    if (!cpfCatogary) {
      getCPFCalCategory();
    }
  }, []);

  useEffect(() => {
    const pathToSearch = location.pathname.split("/").pop();

    if (pathToSearch) {
      setSelectedSection(() => routeToSection[pathToSearch]);
    }
  }, [location]);

  const autoScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  console.log('employeeId', user.employee_id)


  return (
    <DashboardContainer>
      <LeftSection>
        {menu?.includes("dashboard") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("request/data-entry")}
            style={{
              color: selectedSection === "request" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider
              value={{
                color: selectedSection === "request" ? "#28a745" : "#fff9",
                size: "20px",
              }}
            >
              <IoHome />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "request" ? "#28a745" : "#fff9",
              }}
            >
              Dashboard
            </p>
          </div>
        )}
        {(menu?.includes("manage_company") || menu.includes("emp_manage_companies")) && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("manage-company")}
            style={{
              color: selectedSection === "company" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <MdOutlineCorporateFare />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "company" ? "#28a745" : "#fff9",
              }}
            >
              Manage Companies
            </p>
          </div>
        )}
        {menu?.includes("manage_employee") && (
          <div
            className="link-menu-item"
            onClick={ () => payrunStartDate ? handleClick("employee-payroll") : navigate("/dashboard/payrun-date-not-set")}
            style={{
              color: selectedSection === "employee" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider
              value={{
                color: selectedSection === "employee" ? "#28a745" : "#fff9",
                size: "20px",
              }}
            >
              <FaUsers />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "employee" ? "#28a745" : "#fff9",
              }}
            >
              Manage Employees
            </p>
          </div>
        )}

        {menu?.includes("pay_run") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("payment_runs")}
            style={{
              color: selectedSection === "payrun" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <FaDollarSign />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "payrun" ? "#28a745" : "#fff9",
              }}
            >
              Pay Runs
            </p>
          </div>
        )}
        {menu?.includes("payroll") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("tellboss/payroll")}
            style={{
              color: selectedSection === "payroll" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <FaMobileAlt />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "payroll" ? "#28a745" : "#fff9",
              }}
            >
              Payroll-TellBoss
            </p>
          </div>
          // <div className={`sub-menu-list`}>
          //   <div
          //     className="link-menu-item"
          //     onClick={() => setTellbossOpen((p) => !p)}
          //   >
          //     <IconContext.Provider
          //       value={{
          //         color: tellbossSelect ? "#28a745" : "#fff9",
          //         size: "20px",
          //       }}
          //     >
          //       <FaMobileAlt />
          //     </IconContext.Provider>
          //     <p
          //       className="link"
          //       style={{ color: tellbossSelect ? "#28a745" : "#fff9" }}
          //     >
          //       Tellboss
          //     </p>
          //     {!tellbossOpen ? (
          //       <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
          //         <MdArrowDropDown />
          //       </IconContext.Provider>
          //     ) : (
          //       <IconContext.Provider
          //         value={{
          //           color: tellbossSelect ? "#28a745" : "#fff9",
          //           size: "20px",
          //         }}
          //       >
          //         <MdArrowDropUp />
          //       </IconContext.Provider>
          //     )}
          //   </div>
          //   <div className={`sub-menu-list ${tellbossOpen ? "show" : "hide"}`}>
          //     <NavLink
          //       style={({ isActive }) => {
          //         if (isActive) {
          //           handleLinkOpen("tellboss");
          //           return activeStyle;
          //         }
          //       }}
          //       className="sublink"
          //       to="tellboss/payroll"
          //     >
          //       Payroll
          //     </NavLink>
          //   </div>
          // </div>
        )}
        {menu?.includes("filling") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("filing/monthly")}
            style={{
              color: selectedSection === "filing" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <FaTelegramPlane />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "filing" ? "#28a745" : "#fff9",
              }}
            >
              Filing - CPF Monthly
            </p>
          </div>
        )}

        {menu?.includes("report") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("reports")}
            style={{
              color: selectedSection === "manage-report" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <MdOutlineCorporateFare />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color:
                  selectedSection === "manage-report" ? "#28a745" : "#fff9",
              }}
            >
              Reports
            </p>
          </div>
        )}

        {menu?.includes("report_history") && (
          <div className={`sub-menu-list`}>
            <div
              className="link-menu-item"
              onClick={() => setPaySlipOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: payslipSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <AiFillBook />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: payslipSelect ? "#28a745" : "#fff9" }}
              >
                Reports History
              </p>
              {!payslipOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: payslipSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            <div className={`sub-menu-list ${payslipOpen ? "show" : "hide"}`}>
              {menu.includes("ytd_reports") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("payslip");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="payslip/current"
              >
                YTD Reports
              </NavLink>
              }

              {menu.includes("ytd_monthly_payroll_reports") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("payslip");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="payslip/company"
              >
                YTD by Month Report
              </NavLink>}

              {menu.includes("ytd_history_reports") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("payslip");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="payslip/history"
              >
                YTD Employee Reports
              </NavLink>}
            </div>
          </div>
        )}

        {menu?.includes("annual_increment") &&
          <div
            className="link-menu-item"
            onClick={() => handleClick("annual-increment")}
            style={{
              color: selectedSection === "annual-increment" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <MdOutlineCorporateFare />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color:
                  selectedSection === "annual-increment" ? "#28a745" : "#fff9",
              }}
            >
              Annual Increment
            </p>
          </div>
        }
        {menu?.includes("annual_bonus") &&
          <div
            className="link-menu-item"
            onClick={() => handleClick("annual-bonus")}
            style={{
              color: selectedSection === "annual-bonus" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <MdOutlineCorporateFare />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color:
                  selectedSection === "annual-bonus" ? "#28a745" : "#fff9",
              }}
            >
              Annual Bonus
            </p>
          </div>
        }

        {/* {menu?.includes("manual_ir8a") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("filing/manual")}
            style={{
              color: selectedSection === "manual" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <FaFileExcel />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "manual" ? "#28a745" : "#fff9",
              }}
            >
              Manual IR8A
            </p>
          </div>
        )} */}


        {menu?.includes("manage_ir8a") && (
          <div className={`sub-menu-list`}>
            <div
              className="link-menu-item"
              onClick={() => setManageIR8AOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: manageIR8ASelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <FaFileExcel />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: manageIR8ASelect ? "#28a745" : "#fff9" }}
              >
                Manage IR8A IR21
              </p>
              {!manageIR8AOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: manageIR8ASelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            <div className={`sub-menu-list ${manageIR8AOpen ? "show" : "hide"}`}>
              {menu.includes("manual_ir8a") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("manageIR8A");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="filing/manual"
              >
                Manual IR8A
              </NavLink>}
              
              {menu.includes("ir8a_filling") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("manageIR8A");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="filing/iras"
              >
                IRAS Filing (IR8A etc)
              </NavLink>}

              {menu.includes("ir21_filling") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("manageIR8A");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="filing/ir21"
              >
                IRAS Filing (IR21)
              </NavLink>}

              {menu.includes("ir8a_item_mapping") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("manageIR8A");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="filing/ir8a-items-mapping"
              >
                IR8A Items Mapping
              </NavLink>}
            </div>
          </div>
        )}

        {/* {menu?.includes("customer_invoicing") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("customer-invoice")}
            style={{
              color: selectedSection === "invoice" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <AiFillBook />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "invoice" ? "#28a745" : "#fff9",
              }}
            >
              Customer Invoicing
            </p>
          </div>
        )} */}

        {menu?.includes("manage_tms") && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("tms")}
            style={{ color: selectedSection === "tms" ? "#28a745" : "#fff9" }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <AiFillClockCircle />
            </IconContext.Provider>
            <p
              className="link"
              style={{ color: selectedSection === "tms" ? "#28a745" : "#fff9" }}
            >
              Manage TMS
            </p>
          </div>
        )}

        {(menu?.includes("manage_user") || menu?.includes("manage_group") || menu?.includes("manage_group_permission")) && (
          <div className={`sub-menu-list `}>
            <div
              className="link-menu-item"
              onClick={() => setUsersOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: usersSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <MdSupervisedUserCircle />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: usersSelect ? "#28a745" : "#fff9" }}
              >
                Manage Users
              </p>
              {!usersOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: usersSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            <div className={`sub-menu-list ${usersOpen ? "show" : "hide"}`}>
              {menu?.includes("users") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("users");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="users"
              >
                Users
              </NavLink>}

              {menu?.includes("manage_group") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("users");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-users/groups"
              >
                Manage Group
              </NavLink>}

              {menu?.includes("manage_group_permission") && permission === "full" && (
                <NavLink
                  style={({ isActive }) => {
                    if (isActive) {
                      handleLinkOpen("users");
                      return activeStyle;
                    }
                  }}
                  className="sublink"
                  to="manage-users/edit-groups"
                >
                  Manage Groups Permissions
                </NavLink>
              )}
            </div>
          </div>
        )}
        {/* {menu?.includes("cpf_calculator") && (
          <div className={`sub-menu-list `}>
            <div
              className="link-menu-item"
              onClick={() => setCpfOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{ color: cpfSelect ? "#28a745" : "#fff9", size: "20px" }}
              >
                <BsCalculator />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: cpfSelect ? "#28a745" : "#fff9" }}
              >
                CPF Calculator
              </p>
              {!cpfOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: cpfSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            <div>
              {(cpfCatogary || [])?.map((item: any) => (
                <div key={item.id} className={`${cpfOpen ? "show" : "hide"}`}>
                  <NavLink
                    style={({ isActive }) => {
                      if (isActive) {
                        handleLinkOpen("cpf");
                        return activeStyle;
                      }
                    }}
                    className="sublink"
                    to={`cpf-cal/${item.code}`}
                    key={item.id}
                  >
                    {item.name}
                  </NavLink>
                </div>
              ))}
            </div>
          </div>
        )} */}
        {menu?.includes("manage_templates") && (
          <div className={`sub-menu-list`}>
            <div
              className="link-menu-item"
              onClick={() => setTemplateOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: templateSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <FiSettings />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: templateSelect ? "#28a745" : "#fff9" }}
              >
                Manage Templates
              </p>
              {!templateOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: templateSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            <div className={`sub-menu-list ${templateOpen ? "show" : "hide"}`}>
              {menu.includes("hr_templates") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("template");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-template/hr"
              >
                HR Templates
              </NavLink>}
            </div>
          </div>
        )}

        {/* Manage Expenses */}
        {menu?.includes("expense_settings") && (
          <div className={`sub-menu-list`}>
            <div
              className="link-menu-item"
              onClick={() => setExpenseOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: expenseSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <FiSettings />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: expenseSelect ? "#28a745" : "#fff9" }}
              >
                Manage Expenses
              </p>
              {!expenseOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: expenseSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            
            
            <div className={`sub-menu-list ${expenseOpen ? "show" : "hide"}`}>
              {menu.includes("expense_accounts") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("expense");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="expense_settings/expense_accounts"
                >
                Expense Accounts
              </NavLink>}
            </div>

             <div className={`sub-menu-list ${expenseOpen ? "show" : "hide"}`}>
              {menu.includes("manage_expense_user") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("expense");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="expense_settings/manage_expense_user"
                >
                Manage Expense Claims
              </NavLink>}
            </div>
          </div>
        )}

        {/* Manage Expense for Employees */}
        {(menu?.includes("emp_expense_claim")) && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("expense-claims")}
            style={{
              color: selectedSection === "expense" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <MdOutlineCorporateFare />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "expense" ? "#28a745" : "#fff9",
              }}
            >
              Expense Claims
            </p>
          </div>
        )}

        {/* Manage Invoice */}
        {menu?.includes("manage_invoices") && (
          <div className={`sub-menu-list`}>
            <div
              className="link-menu-item"
              onClick={() => setManageInvoicingOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: manageInvoiceSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <AiFillBook />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: manageInvoiceSelect ? "#28a745" : "#fff9" }}
              >
                Manage Invoice
              </p>
              {!ManageInvoicingOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: manageInvoiceSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            <div className={`sub-menu-list ${ManageInvoicingOpen ? "show" : "hide"}`}>
              {menu.includes("invoice_summary") && (
                <NavLink
                  style={({ isActive }) => {
                    if (isActive) {
                      handleLinkOpen("manage_invoice");
                      return activeStyle;
                    }
                  }}
                  className="sublink"
                  to="manage_invoicing/invoice"
                >
                  Invoice Summary
                </NavLink>
              )}

              {menu.includes("repeated_invoice") && (
                <NavLink
                  style={({ isActive }) => {
                    if (isActive) {
                      handleLinkOpen("manage_invoice");
                      return activeStyle;
                    }
                  }}
                  className="sublink"
                  to="manage_invoicing/repeatedinvoice"
                >
                  Repeated Invoice
                </NavLink>
              )}
            </div>
          </div>
        )}

        {/* Manage Custom Item */}
        {menu?.includes("manage_report") && (
          <div className={`sub-menu-list`}>
            <div
              className="link-menu-item"
              onClick={() => setManageCustomItemOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: manageCustomItemSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <MdOutlineCorporateFare />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: manageCustomItemSelect ? "#28a745" : "#fff9" }}
              >
                Manage Custom Item
              </p>
              {!manageCustomItemOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: manageCustomItemSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>
            <div className={`sub-menu-list ${manageCustomItemOpen ? "show" : "hide"}`}>
              {menu.includes("custom_pay_item") && (
                <NavLink
                  style={({ isActive }) => {
                    if (isActive) {
                      handleLinkOpen("manage_custom_item");
                      return activeStyle;
                    }
                  }}
                  className="sublink"
                  to="manage-global-report/manage-custom-report"
                >
                  Custom Pay Item
                </NavLink>
              )}
            </div>
          </div>
        )}




        {/* Manage Invoicing */}
{/* 
        {menu?.includes("manage_invoicing") && (
          <div className="sub-menu-list">
            Parent Menu: Manage Invoicing
            <div
              className="link-menu-item"
              onClick={() => setManageInvoicingOpen((prev) => !prev)}
            >
              <IconContext.Provider
                value={{
                  color: manageInvoiceSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <FiSettings />
              </IconContext.Provider>
              <p
                className="link"
                style={{
                  color: manageInvoiceSelect || GlobalInvoiceselect ? "#28a745" : "#fff9",
                }}
              >
                Manage Invoicing
              </p>
              {ManageInvoicingOpen ? (
                <IconContext.Provider
                  value={{
                    color: manageInvoiceSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              )}
            </div>

            Submenu: Manage Invoicing
            {ManageInvoicingOpen && (
              <div className="sub-menu-list show">
                {menu.includes("company_level_invoices") && (
                  <NavLink
                    style={({ isActive }) => {
                      if (isActive) {
                        handleLinkOpen("manage_invoice");
                        return activeStyle;
                      }
                    }}
                    className="sublink"
                    to="manage_invoicing/company_level_invoice"
                  >
                    Company Level Invoices
                  </NavLink>
                )}

                Submenu: Global Level Invoices
                {menu.includes("global_level_invoices") && (
                  <div>
                    <div
                      className="link-menu-item"
                      onClick={() => setGlobalInvoiceopen((prev) => !prev)}
                    >
                      <p
                        className="link"
                        style={{
                          color: GlobalInvoiceselect ? "#28a745" : "#fff9",
                          paddingLeft: "25px",
                        }}
                      >
                        Global Level Invoices
                      </p>
                    </div>

                    {GlobalInvoiceopen && (
                      <div className="sub-menu-list show">
                        {menu.includes("global_level_invoices") && (
                          <NavLink
                            style={({ isActive }) => {
                              if (isActive) {
                                handleLinkOpen("global_level_invoices");
                                return activeStyle;
                              }
                            }}
                            className="sublink"
                            to="manage_invoicing/global_level_invoice/current"
                          >
                            Global Invoices - Current Month
                          </NavLink>
                        )}

                        {menu.includes("global_level_invoices") && (
                          <NavLink
                            style={({ isActive }) => {
                              if (isActive) {
                                handleLinkOpen("global_level_invoices");
                                return activeStyle;
                              }
                            }}
                            className="sublink"
                            to="manage_invoicing/global_level_invoice/past"
                          >
                            Global Invoices - Past Month/Year
                          </NavLink>
                        )}
                      </div>
                    )}
                  </div>
                )}

                Submenu: Generate Global Invoices
                {menu.includes("generate_global_invoices") && (
                  <NavLink
                    style={({ isActive }) => {
                      if (isActive) {
                        handleLinkOpen("manage_invoice");
                        return activeStyle;
                      }
                    }}
                    className="sublink"
                    to="manage_invoicing/generate_global_invoice"
                  >
                    Generate Global Invoices
                  </NavLink>
                )}
              </div>
            )}
          </div>
        )} */}


        
        {/* {menu?.includes("manage_invoicing")  && (
          <div className="sub-menu-list">
            <div
              className="link-menu-item"
              onClick={() => setManageInvoicingOpen((prev) => !prev)}
            >
              <IconContext.Provider
                value={{
                  color: manageInvoiceSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <FiSettings />
              </IconContext.Provider>
              <p
                className="link"
                style={{
                  color: manageInvoiceSelect || GlobalInvoiceselect ? "#28a745" : "#fff9",
                }}
              >
                Manage Invoicing
              </p>
              {ManageInvoicingOpen ? (
                <IconContext.Provider
                  value={{
                    color: manageInvoiceSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              )}
            </div>

            {ManageInvoicingOpen && (
              <div className="sub-menu-list show">
                {menu.includes("company_level_invoices") && (
                  <NavLink
                    style={({ isActive }) => {
                      if (isActive) {
                        handleLinkOpen("manage_invoice");
                        return activeStyle;
                      }
                    }}
                    className="sublink"
                    to="manage_invoicing/invoice"
                  >
                    Invoices
                  </NavLink>
                )}
                {menu.includes("company_level_invoices") && (
                  <NavLink
                    style={({ isActive }) => {
                      if (isActive) {
                        handleLinkOpen("manage_invoice");
                        return activeStyle;
                      }
                    }}
                    className="sublink"
                    to="manage_invoicing/repeatedinvoice"
                  >
                    Repeated Invoice

                  </NavLink>
                )}


              </div>
            )}
          </div>)} */}


        {(menu?.includes("app_setting") || menu?.includes("manage_cpf_limit") || menu?.includes("manage_cpf_table") || menu?.includes("manage_cpf_sdl") || menu?.includes("manage_deduction") || menu?.includes("manage_invoicing")) && (
          <div className={`sub-menu-list`}>
            <div
              className="link-menu-item"
              onClick={() => setSettingOpen((p) => !p)}
            >
              <IconContext.Provider
                value={{
                  color: settingSelect ? "#28a745" : "#fff9",
                  size: "20px",
                }}
              >
                <FiSettings />
              </IconContext.Provider>
              <p
                className="link"
                style={{ color: settingSelect ? "#28a745" : "#fff9" }}
              >
                Settings
              </p>
              {!settingOpen ? (
                <IconContext.Provider value={{ color: "#fff9", size: "20px" }}>
                  <MdArrowDropDown />
                </IconContext.Provider>
              ) : (
                <IconContext.Provider
                  value={{
                    color: settingSelect ? "#28a745" : "#fff9",
                    size: "20px",
                  }}
                >
                  <MdArrowDropUp />
                </IconContext.Provider>
              )}
            </div>


            <div className={`sub-menu-list ${settingOpen ? "show" : "hide"}`}>


              {menu?.includes("manage_cpf_table") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-cpf-table"
              >
                Manage CPF Table
              </NavLink>}

              {menu?.includes("manage_cpf_limit") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-cpf-limit"
              >
                Manage CPF Limit
              </NavLink>}

              {menu?.includes("manage_deduction") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-deduction"
              >
                Manage SHG
              </NavLink>}

              {menu?.includes("manage_sdl") && <NavLink
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-sdf"
              >
                Manage SDL
              </NavLink>}


              {menu?.includes("manage_spc") && <NavLink
                onClick={() => handleClick("manage-spc")}
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-spc"
              >
                Manage SPC
              </NavLink>}



              {/* {menu?.includes("manage_report") && <NavLink
                onClick={() => handleClick("manage-global-report")}
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-global-report/manage-custom-report"
              >
                Manage Custom Items
              </NavLink>} */}

              {menu?.includes("manage_service_code") && <NavLink
                onClick={() => handleClick("manage-service-code")}
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage-service-code"
              >
                Manage Service Codes
              </NavLink>}

              {/* {menu?.includes("manage_invoices") && <NavLink
                onClick={ ()=> handleClick("manage_invoicing/invoice")}
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage_invoicing/invoice"
              >
                Manage Invoices

              </NavLink>} */}
              {menu?.includes("manage_repeated_invoice") && <NavLink
                onClick={ ()=> handleClick("manage_invoicing/repeatedinvoice")}
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="manage_invoicing/repeatedinvoice"
              >
                Manage Repeated Invoices

              </NavLink>}
              {menu?.includes("manage_setup_settings") && <NavLink
                onClick={handleAppSettingClick}
                style={({ isActive }) => {
                  if (isActive) {
                    handleLinkOpen("setting");
                    return activeStyle;
                  }
                }}
                className="sublink"
                to="app-settings/employer-details"
              >
                Manage Set-up Settings

              </NavLink>}

            </div>
          </div>
        )}

        {(menu?.includes("leave_approval")) && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("approve")}
            style={{
              color: selectedSection === "approve" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <FaCheck />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "approve" ? "#28a745" : "#fff9",
              }}
            >
              Leave Approval
            </p>
          </div>
        )}

        {/* {(userGroupIds.includes(11) || isSuperUser) && <div style={{  */}
        {( isEmployee) && <div style={{ 
              marginBottom: '3rem' }}>
          {/* {<div
            className="link-menu-item"
            style={{
              color: "#fff9",
            }}
          >
            <p
              style={{
                borderBottom: "1px solid #fff9",
                width: "90%",
                paddingBottom: 5,
              }}
            >
              <strong>Employee</strong>
            </p>
          </div>} */}

          {menu?.includes("payslip") && (
            <div
              className="link-menu-item"
              onClick={() => handleClick("payslips")}
              style={{
                color: selectedSection === "payslips" ? "#28a745" : "#fff9",
              }}
            >
              <IconContext.Provider value={{ size: "20px" }}>
                <FaDollarSign />
              </IconContext.Provider>
              <p
                className="link"
                style={{
                  color: selectedSection === "payslips" ? "#28a745" : "#fff9",
                }}
              >
                Payslips
              </p>
            </div>
          )}
          {menu?.includes("request") && (
            <div
              className="link-menu-item"
              onClick={() => handleClick("requests")}
              style={{
                color: selectedSection === "requests" ? "#28a745" : "#fff9",
              }}
            >
              <IconContext.Provider value={{ size: "20px" }}>
                <FaRegCalendarCheck />
              </IconContext.Provider>
              <p
                className="link"
                style={{
                  color: selectedSection === "requests" ? "#28a745" : "#fff9",
                }}
              >
                Requests
              </p>
            </div>
          )}

          {( menu.includes("emp_leave_approval")) && (
          <div
            className="link-menu-item"
            onClick={() => handleClick("approve")}
            style={{
              color: selectedSection === "approve" ? "#28a745" : "#fff9",
            }}
          >
            <IconContext.Provider value={{ size: "20px" }}>
              <FaCheck />
            </IconContext.Provider>
            <p
              className="link"
              style={{
                color: selectedSection === "approve" ? "#28a745" : "#fff9",
              }}
            >
              Leave Approval
            </p>
          </div>
        )}
        </div>}
        
      </LeftSection>
      <RightSection>
        <Outlet />
      </RightSection>
    </DashboardContainer>
  );
};

export default memo(Dashboard);
